import React from "react";

export const formatTimeDifference = (diff: number) => {
  const days = Math.floor(Math.abs(diff) / (24 * 60 * 60 * 1000));
  const hours = Math.floor((Math.abs(diff) % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const mins = Math.floor((Math.abs(diff) % (60 * 60 * 1000)) / (60 * 1000));

  const sign = diff < 0 ? '-' : '';

  const renderSegment = (value: number, unit: string) => (
    <span key={unit} className="time-segment">
      <span className="time-value">{value}</span>
      <span className="time-unit">{unit}</span>
    </span>
  );

  const segments = [];

  if (days > 0) {
    segments.push(renderSegment(days, 'd'), renderSegment(hours, 'h'), renderSegment(mins, 'm'));
  } else if (hours > 0) {
    segments.push(renderSegment(hours, 'h'), renderSegment(mins, 'm'));
  } else {
    segments.push(renderSegment(mins, 'm'));
  }

  return (
    <span className="formatted-time-difference">
      {sign && <span className="time-sign">{sign}</span>}
      {segments}
    </span>
  );
};
